import React, { useEffect, useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import ChefContent from "../components/chefDetailWidgets/ChefContent";
import FilterAndDate from "../components/chefDetailWidgets/FilterAndDate";
import { handleGetChefWithDishes } from "../../services/get_without_auth";
import { handleChefPostReview, handleGetAllReview } from "../../services/order";
import { useParams } from "react-router-dom";
import { chefIdFromSlug } from "../../shefPath";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";

export const ShefDetailPage = () => {
  const { authToken } = useSelector((state) => state.user);
  const { chefId: chefSlug } = useParams();
  const chefId = chefIdFromSlug(chefSlug);
  const [chefAndDishes, setChefAndDishes] = useState([]);
  // Get chef with dishes
  useEffect(() => {
    (async () => {
      try {
        const city = JSON.parse(localStorage.getItem("region"));
        const response = await handleGetChefWithDishes(chefId, city.id);
        console.log("response of chef with dishes ", response);
        setChefAndDishes(response);
      } catch (error) {
        console.error(error);
        console.error("message", error.message);
        const message = error.message;
        if (message != "Request failed with status code 404") {
          toast.error(error);
        } else if (message === "Request failed with status code 404") {
          toast.error("chef isn't found in this city");
        }
      }
    })();
  }, [chefId]);
  // console.log(chefAndDishes)

  // State to hold the array of feedbacks (messages)
  const [feedbackList, setFeedbackList] = useState([]);
  // State to hold the input field value (single message)
  const [feedbackMessage, setFeedbackMessage] = useState("");

  const [reviews, setReviews] = useState([]);
  // const [reviews, setReviews] = useState([
  //     { userName: 'John Doe', message: 'This is great!' },
  //     { userName: 'Jane Smith', message: 'Nice job!' },
  // ]);

  // Handle input change (for the message input field)
  const handleInputChange = (event) => {
    setFeedbackMessage(event.target.value);
  };

  // Handle form submission (posting feedback)
  const handlePostFeedback = async (event) => {
    event.preventDefault(); // Prevent the form from refreshing the page

    if (feedbackMessage.trim()) {
      // Add the new feedback as an object to the feedback list
      setFeedbackList((prevFeedbackList) => [
        ...prevFeedbackList,
        { message: feedbackMessage }, // Store feedback as an object with a 'message' key
      ]);

      console.log(feedbackMessage);
      const respons = await handleChefPostReview(
        authToken,
        chefId,
        feedbackMessage
      );

      setFeedbackMessage(""); // Clear the input field after posting feedback
    } else {
      alert("Please type some feedback.");
    }
  };

  useEffect(() => {
    (async () => {
      try {
        const response = await handleGetAllReview(authToken, chefId);

        console.log("response of reviews", response.data);
        setReviews(response.data.original.data.data);
      } catch (error) {
        console.error(error);
        console.error("message", error.message);
        const message = error.message;
        if (message != "Request failed with status code 404") {
          toast.error(error);
        } else if (message === "Request failed with status code 404") {
          toast.error("chef isn't found in this city");
        }
      }
    })();
  }, [chefId]);
  // const [expandedReview, setExpandedReview] = useState(null);

  // const toggleReplies = (reviewId) => {
  //   setExpandedReview((prev) => (prev === reviewId ? null : reviewId));
  // };

  const [expandedReviews, setExpandedReviews] = useState({});

  const toggleReadMore = (reviewId) => {
    setExpandedReviews((prevState) => ({
      ...prevState,
      [reviewId]: !prevState[reviewId],
    }));
  };

  const toggleReplies = (reviewId) => {
    setExpandedReviews((prevState) => ({
      ...prevState,
      [`replies_${reviewId}`]: !prevState[`replies_${reviewId}`],
    }));
  };

  return (
    <>
      <Header />

      <div className="shefDetail_page">
        <ChefContent chefAndDishes={chefAndDishes} />
        <FilterAndDate chefAndDishes={chefAndDishes} />

        <div className="container mx-auto px-4 lg:px-4 py-4 overflow-x-hidden">
          <h2 className="md:text-2xl text-xl uppercase font-bold tracking-wider mb-4">
            REVIEWS
          </h2>
          <div className="flex flex-col gap-3">
            <div className="bg-gray-50 rounded-lg shadow-sm overflow-y-auto max-h-[420px] scrollbar-thin scrollbar-thumb-[#f02444] scrollbar-track-[#f0f0f0]">
              <div className="px-4 py-3">
                {reviews.length > 0 ? (
                  reviews.map((review) => (
                    <div key={review.id} className="mb-4">
                      <div className="bg-white rounded-lg p-3 shadow-sm border border-gray-100 hover:shadow-md transition-shadow duration-200 space-y-2">
                        <div className="flex items-start gap-3">
                          {review.user_menu?.user?.profile_pic ? (
                            <img
                              src={review.user_menu.user.profile_pic}
                              alt="Reviewer"
                              className="w-10 h-10 rounded-full border border-gray-200 flex-shrink-0"
                            />
                          ) : (
                            <div className="w-10 h-10 rounded-full bg-gray-200 flex items-center justify-center text-gray-500 flex-shrink-0">
                              <span className="text-xs font-medium">
                                {review?.user_menu?.user?.first_name?.charAt(0) || 'N'}
                              </span>
                            </div>
                          )}
                          <div className="flex-1 min-w-0">
                            <div className="flex items-center justify-between flex-wrap gap-1 mb-1">
                              <p className="text-gray-800 text-sm font-semibold">
                                {`${review?.user_menu?.user?.first_name || ""} ${review?.user_menu?.user?.last_name || ""}`}
                              </p>
                              <div className="flex items-center gap-2">
                                <div className="inline-flex items-center gap-x-1 px-2 py-0.5 rounded-md bg-[#ffc00047]">
                                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="10" height="10" fill="#323232">
                                    <path d="M12.0006 18.26L4.94715 22.2082L6.52248 14.2799L0.587891 8.7918L8.61493 7.84006L12.0006 0.5L15.3862 7.84006L23.4132 8.7918L17.4787 14.2799L19.054 22.2082L12.0006 18.26Z"></path>
                                  </svg>
                                  <span className="text-xs font-semibold">
                                    {review?.user_menu?.average_rating
                                      ? parseFloat(review?.user_menu?.average_rating).toFixed(1)
                                      : 0}
                                  </span>
                                  <span className="text-[11px] text-gray-500">
                                    ({review?.user_menu?.total_reviews})
                                  </span>
                                </div>
                                {review.created_at && (
                                  <span className="text-[11px] text-gray-400">
                                    {new Date(review.created_at).toLocaleDateString()}
                                  </span>
                                )}
                              </div>
                            </div>
                            <p className="text-gray-700 text-sm break-words whitespace-normal leading-snug">
                              {expandedReviews[review.id]
                                ? review.review
                                : review.review?.slice(0, 300) || "No message provided"}
                              {review.review?.length > 300 && (
                                <button
                                  className="text-blue-500 ml-1 text-xs font-medium"
                                  onClick={() => toggleReadMore(review.id)}
                                >
                                  {expandedReviews[review.id] ? "Read Less" : "Read More"}
                                </button>
                              )}
                            </p>
                          </div>
                        </div>
                        {review.replies.length > 0 && (
                          <button
                            onClick={() => toggleReplies(review.id)}
                            className="text-blue-500 text-xs underline ml-1"
                          >
                            {expandedReviews[`replies_${review.id}`]
                              ? "Hide Replies"
                              : `View Replies (${review.replies.length})`}
                          </button>
                        )}
                      </div>
                      {expandedReviews[`replies_${review.id}`] && (
                        <div className="mt-2 ml-5">
                          {review.replies.map((reply) => (
                            <div
                              key={reply.id}
                              className="bg-gray-50 border-l-4 border-blue-400 pl-3 py-2 rounded-lg mb-2 flex items-start gap-2"
                            >
                              {reply.user?.profile_pic ? (
                                <img
                                  src={reply.user.profile_pic}
                                  alt="Replier"
                                  className="w-8 h-8 rounded-full border border-gray-300 flex-shrink-0"
                                />
                              ) : (
                                <div className="w-8 h-8 rounded-full bg-gray-200 flex items-center justify-center text-gray-500 flex-shrink-0">
                                  <span className="text-xs">{reply.user?.first_name?.charAt(0) || 'N'}</span>
                                </div>
                              )}
                              <div>
                                <p className="text-gray-800 text-sm">{reply.reply}</p>
                                <p className="text-gray-500 text-xs mt-0.5">
                                  By:{" "}
                                  <span className="font-semibold">
                                    {reply.user.first_name} {reply.user.last_name}
                                  </span>{" "}
                                  · {new Date(reply.created_at).toLocaleDateString()}
                                </p>
                              </div>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  ))
                ) : (
                  <div className="text-center py-10 text-gray-400">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="40" height="40" fill="#d1d5db" className="mx-auto mb-3">
                      <path d="M6.455 19L2 22.5V4C2 3.44772 2.44772 3 3 3H21C21.5523 3 22 3.44772 22 4V18C22 18.5523 21.5523 19 21 19H6.455Z"></path>
                    </svg>
                    <p className="text-base font-semibold mb-1">No Reviews Yet</p>
                    <p className="text-sm">Be the first to share your experience!</p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};
export default ShefDetailPage;